/* eslint-disable @typescript-eslint/no-explicit-any */

import { Component, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { RoutingService } from 'src/app/service/routing.service';
import { AuthService } from 'src/app/service/auth.service';
import { PortfolioApiService } from 'src/app/shared/services/customer-api/portfolio-api.service';
import { ConfigService } from 'src/app/service/config.service';
import { BreakpointService } from 'src/app/shared/services/breakpoints.service';
import { ReportStateService } from 'src/app/shared/services/report-state.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-scanner-main',
  templateUrl: './scanner-main.component.html',
  styleUrls: ['./scanner-main.component.scss'],
})
export class ScannerMainComponent {
  items: any[] = [];
  isDialogOpen: boolean = false;
  screenSize$ = this.breakpointService.screenSize$;

  constructor(
    public routing: RoutingService,
    public auth: AuthService,
    public config: ConfigService,
    private breakpointService: BreakpointService,
    public reportStateService: ReportStateService,
    public portfolioApi: PortfolioApiService,
  ) {
    this.portfolioApi.activePortfolio$
      .pipe(
        filter((folio): folio is NonNullable<typeof folio> => !!folio?.uid),
        distinctUntilChanged((a, b) => a.uid === b.uid),
        takeUntilDestroyed(),
      )
      .subscribe((folio) => {
        this.reportStateService.checkStatuses({
          mode: 'entity',
          entity: { type: 'portfolio', alpha_id: folio.uid, name: folio.name },
          folio,
          customScore: this.auth.scorelabSettings.defaultScore,
        });
      });
  }

  handleItems(items: any) {
    this.items = items;
  }
}
